var _path, _rect;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.18638 18.5004H6.69844V10.4884H9.18638V18.5004ZM7.94091 9.39553C7.14545 9.39553 6.5 8.73637 6.5 7.94091C6.5 7.55876 6.65181 7.19226 6.92203 6.92203C7.19226 6.65181 7.55876 6.5 7.94091 6.5C8.32306 6.5 8.68956 6.65181 8.95978 6.92203C9.23001 7.19226 9.38182 7.55876 9.38182 7.94091C9.38182 8.73637 8.73637 9.39553 7.94091 9.39553ZM18.4979 18.5004H16.0155V14.6003C16.0155 13.6707 15.9966 12.4788 14.722 12.4788C13.4285 12.4788 13.2301 13.4885 13.2301 14.5334V18.5004H10.7447V10.4884H13.1307V11.5813H13.1654C13.4975 10.9517 14.3089 10.2874 15.5192 10.2874C18.0371 10.2874 18.5 11.9456 18.5 14.0993V18.5004H18.4979Z",
    fill: "#2B2B2E"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 23,
    height: 23,
    rx: 11.5,
    stroke: "#2B2B2E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.93d2ea1c7a47963f9e548f7820840e00.svg";
export { ForwardRef as ReactComponent };